import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Clipboard } from '@capacitor/clipboard';
import { IonIcon, IonSkeletonText, ModalController } from '@ionic/angular/standalone';
import { DisplayService } from "@qid/core";
import { Environment, ENVIRONMENT } from "@qid/env";
import { SexyModule } from '@qid/sexy';
import { QRCodeComponent } from 'angularx-qrcode';
import { Scanner } from "../../models/scanner";
import { ViewScannerComponent } from '../view-scanner/view-scanner.component';

@Component({
  selector: 'template-qr-view',
  templateUrl: './template-qr-view.component.html',
  styleUrls: ['./template-qr-view.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonIcon,
    IonSkeletonText,
    SexyModule,
    QRCodeComponent
  ]
})
export class TemplateQrViewComponent implements OnInit {
  @Input() type: string = 'stand';
  @Input() baseUrl: string = this.env.collectUrl;
  @Input() loading: boolean = false;
  @Input() showCopy: boolean = true;
  @Input() showCode: boolean = false;
  @Output() deleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() collected: EventEmitter<any> = new EventEmitter<any>();
  @Output() refresh: EventEmitter<any> = new EventEmitter<any>();
  @Input() scanner: Scanner = new Scanner();
  @Input() showEditButton: boolean = false;
  @Input() skeletonOnly: boolean = false;

  constructor(
    private modalController: ModalController,
    private router: Router,
    private displayService: DisplayService,
    @Inject(ENVIRONMENT) private env: Environment
  ) {
  }

  ngOnInit() {
  }

  ngOnChanges() {

  }

  public async copy(elementRef: HTMLDivElement) {
    await Clipboard.write({
      url: this.baseUrl + this.scanner.qr,
      label: 'Copied',
    }).then(() => {
      this.displayService.toast({ message: 'Copied to clipboard' });
    });
    elementRef.style.background = '#28ba62';
    setTimeout(() => {
      elementRef.style.background = 'rgba(0, 0, 0, 0.32)';
    }, 400);
  }


  async viewScanner() {
    const modal = await this.modalController.create({
      component: ViewScannerComponent,
      componentProps: {
        scanner: JSON.parse(JSON.stringify(this.scanner)),
      },
    });
    await modal.present();

    const data = await modal.onDidDismiss();
    if (data?.data?.scanner) {
      this.scanner = data.data.scanner;
      this.refresh.emit(this.scanner);
    }
    if (data?.data?.deleted) {
      this.deleted.emit();
    }
  }

  getUniqueCode(code) {
    if (!code) {
      return;
    }
    return code.toString().slice(-5);
  }

  getTitle() {
    if (!this.scanner?.scannerTemplateOptions) {
      return this.scanner.template?.purpose
    }
    return this.scanner.scannerTemplateOptions.length > 1 ? this.scanner.commonTitle : this.scanner.scannerTemplateOptions[0]?.template?.purpose
  }
}
